import axios from "axios";
import AXIOS from "../services/axios";

let baseUrl = "https://graph.facebook.com/v20.0";

export const getUserInfo = async (userId, access_token) => {
  const response = { data: null, error: null };
  try {
    const { data } = await axios.get(
      `${baseUrl}/${userId}?&access_token=${access_token}&fields=name,id,picture`
    );
    response.data = data;
  } catch (err) {
    response.error = err;
  }
  return response;
};

export const getLongUserToken = async (access_token) => {
  const response = { data: null, error: null };
  try {
    const { data } = await axios.get(
      `${baseUrl}/oauth/access_token?grant_type=fb_exchange_token&client_id=${
        process.env.REACT_APP_FB_APP_ID}&client_secret=${
          process.env.REACT_APP_FB_APP_SECRECT_KEY}&fb_exchange_token=${access_token}`
    );
    response.data = data;
  } catch (err) {
    response.error = err;
  }
  return response;
};

export const submitFBTokens = async (info) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/fbupload/fb_token/`,
      info
    );
    response.data = data;
  } catch (err) {
    response.error = err;
  }
  return response;
};